import React, { useEffect, useState, useRef } from 'react';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { encodeId, slugify } from '../../helper/helperFunction';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { useCountryPrefix } from '../../routes/useCountryPrefix';
import { useTranslation } from 'react-i18next';



const MapSec = (props) => {
    const countryPrefix = useCountryPrefix();
    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const currentLang = i18n.language === "en" ? "" : i18n.language || "";

    const mapKey = process.env.REACT_APP_MAP_API_KEY
    const mapLat = countryPrefix === "eg" ? process.env.REACT_APP_MAP_DEFAULT_LAT : process.env.REACT_APP_MAP_DEFAULT_AE_LAT
    const mapLng = countryPrefix === "eg" ? process.env.REACT_APP_MAP_DEFAULT_LNG : process.env.REACT_APP_MAP_DEFAULT_AE_LNG

    const { projectLatLong } = props
    const projectLocation = projectLatLong
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null); // For the Google Map instance
    const [markers, setMarkers] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [projectNames, setProjectNames] = useState([]);

    const location = useLocation();
    const queryParamProjectName = new URLSearchParams(location.search).get('p');


    useEffect(() => {
        if (projectLocation && projectLocation.length > 0) {
            const names = projectLocation?.map(project => ({
                value: slugify(project.projectName),
                label: project.projectName
            }));
            setProjectNames(names);
        }
    }, [projectLocation]);


    useEffect(() => {

        const loadGoogleMaps = () => {
            // Make sure to replace with your actual Google Maps API Key
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${mapKey}&callback=initMap`;
            script.async = true;
            document.body.appendChild(script);
        };

        window.initMap = initMap; // Make sure to assign to the global window object
        loadGoogleMaps();

        return () => {
            delete window.initMap;
        };

    }, []);

    useEffect(() => {
        if (queryParamProjectName) {
            const project = projectLocation?.find(
                (item) => slugify(item.projectName) === queryParamProjectName
            );

            if (project) {
                setSelectedProject({
                    value: queryParamProjectName,
                    label: project.projectName
                });
                performSearch(project.projectName);


                const url = new URL(window.location);
                url.searchParams.delete('p');
                window.history.replaceState({}, '', url);
            }
        }
    }, [markers]);


    const initMap = () => {
        const map = new window.google.maps.Map(mapRef.current, {
            zoom: 8,
            center: { lat: parseFloat(mapLat), lng: parseFloat(mapLng) },
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            keyboardShortcuts: false,
            //gestureHandling: 'greedy',
            zoomControl: true,
            scaleControl: false,
            disableDefaultUI: true,
            clickableIcons: false,
            mapTypeId: "satellite"

        });

        mapInstanceRef.current = map; // Store the map instance

        const markerList = [];

        projectLocation && projectLocation?.forEach(item => {
            const lat = item.locationLatitude
            const lng = item.locationLongitude

            if (!lat || !lng) return

            const marker = new window.google.maps.Marker({
                position: { lat: lat, lng: lng },
                map: map,
                title: item.projectName,
                animation: window.google.maps.Animation.DROP,
                icon: {
                    url: "/assets/img/marker.png", // must be public
                    //scaledSize: new window.google.maps.Size(40, 50) // optional, resize icon
                }
            });

            const infowindow = new window.google.maps.InfoWindow({
                // content: `<h3>${location.projectName}</h3><p>${location.developerName}</p>`
                content: `<div style="max-width:300px; box-shadow: 0; background: #fff; border: 1px solid #FFFFFF; border-radius: 15px;">
                        <img src=${item.thumbnailImage} alt="location" style="width: 100%; border-radius: 15px; margin-top: 0px; height: 150px; object-fit: cover;">
                        <h2 style="font-size: 20px; line-height: normal; margin: 15px 0px; padding: 0px 0px; color: #222;">${item.projectName}</h2>
                        <p style="font-size: 16px; line-height: normal; margin: 0px 0px 15px; padding: 0px 0px; color: #555; }">${item.developerName}</p>
                        <p style="font-size: 16px; line-height: normal; margin: 0px 0px 15px; padding: 0px 0px; color: #555; }">${item.location}</p>
                        <a href=${`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/developers/${slugify(item.developerName)}/project/${slugify(item.projectName)}/${encodeId((item.projectId))}`} target="_blank" style="margin-top: 0px; padding: 10px 30px; background: #1282A6; color: #fff; border: none; border-radius: 30px; text-decoration: none; font-size: 16px; line-height: normal; display: inline-block;">Visit</a>
                        </div>`


            });

            marker.addListener('click', () => {

                markerList.forEach(obj => {
                    obj.infowindow.close();
                });

                infowindow.open(map, marker);
                map.setCenter(marker.getPosition());
                map.setZoom(18); // Zoom in when marker is clicked

                setSelectedProject({
                    value: slugify(item.projectName),
                    label: item.projectName
                });

            });

            markerList.push({ marker, title: item.projectName.toLowerCase(), infowindow });
        });

        setMarkers(markerList);

        // Initialize MarkerClusterer

        // new MarkerClusterer({
        //     markers: markerList.map(obj => obj.marker),
        //     map: map
        // });

        new MarkerClusterer({
            markers: markerList.map(obj => obj.marker),
            map,
            // renderer: {
            //     render: ({ count, position }) => {
            //         let fillColor = "#0083a4"; // default
            //         if (count < 10) fillColor = "#2ecc71";       // green
            //         else if (count < 50) fillColor = "#f1c40f";  // yellow
            //         else if (count < 100) fillColor = "#e67e22"; // orange
            //         else fillColor = "#e74c3c";                  // red

            //         const size = 40;

            //         //     const svg = window.btoa(`
            //         //   <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
            //         //     <circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 2}" fill="${fillColor}" stroke="#fff" stroke-width="3" />
            //         //     <text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#fff" font-size="14">${count}</text>
            //         //   </svg>
            //         // `);

            //         return new window.google.maps.Marker({
            //             position,
            //             // icon: {
            //             //     url: `data:image/svg+xml;base64,${svg}`,
            //             //     scaledSize: new window.google.maps.Size(size, size),
            //             // },
            //             // label: {
            //             //     text: String(count),
            //             //     color: "#fff",
            //             //     fontSize: "12px",
            //             //     fontWeight: "bold",
            //             // },
            //             zIndex: Number(window.google.maps.Marker.MAX_ZINDEX) + count,
            //         });
            //     }
            // }
        });
    };


    const resetMap = () => {
        const center = { lat: parseFloat(mapLat), lng: parseFloat(mapLng) }
        mapInstanceRef.current.setCenter(center);
        mapInstanceRef.current.setZoom(8);
        markers.forEach(obj => {
            obj.infowindow.close();
        });
    }
    const performSearch = (searchTerm) => {

        markers.forEach(obj => {
            if (obj.title.includes(searchTerm.toLowerCase()) && searchTerm !== '') {

                // Open the InfoWindow
                if (obj.infowindow) {
                    obj.infowindow.open(mapInstanceRef.current, obj.marker);
                }
                mapInstanceRef.current.setCenter(obj.marker.getPosition());
                mapInstanceRef.current.setZoom(18);
            } else {
                obj.infowindow.close();
            }
        });
    };



    return (
        <>
            <style>
                {`
                .gm-style-iw-chr {
                    position: absolute !important;
                    right: 0 !important;
                    top: 0 !important;
                    background: #0083a4 !important;
                    color: #fff !important;
                    border-radius: 0px 7px 0px 10px !important;
                }
                    .gm-style-iw-chr button span {
                        filter: brightness(0) invert(1) !important;
                        }
                    .gm-style .gm-style-iw-c {
                    overflow: visible !important;
                    max-height: none !important;
                    padding: 10px !important;
                    }
                    .gm-style .gm-style-iw-d {
                    overflow: visible !important;
                    max-height: none !important;
                    }
                `}
            </style>

            <section className='custom-map'>
                <div className='custom-map-input'>
                    <Select
                        options={projectNames}
                        value={selectedProject}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                setSelectedProject(selectedOption); // when a project is selected
                                performSearch(selectedOption.label);
                            } else {
                                setSelectedProject(null); // when cleared (cross button clicked)
                                resetMap()
                            }
                        }}

                        placeholder="Search for a place..."
                        isSearchable={true} // Enable searchability
                        isClearable={true} // Allow clearing of the search field

                    />
                </div>
                <div
                    id="map"
                    className="custom-map-sizing"
                    ref={mapRef}
                    style={{ width: '100%' }}
                ></div>
            </section>
        </>
    )
}

export default MapSec